import React, { useContext, useEffect, useState } from "react";
import Equipment from "./Equipment";
import EquipmentTile from "./EquipmentTile";
import { EquipmentContext } from "../useContext/context";
import { Button } from "@mui/material";
import { FaPlusCircle } from "react-icons/fa";
import TextField from "../../../../elements/TextField";

const Category = ({
    enableLegend,
    category,
    updateSelectedEquipments,
    form_data,
    setFormDataByKeyValue,
    allEquipments,
}) => {
    const [expandedDevice, setExpandedDevice] = useState({});
    const { isDeviceExpanded, setIsDeviceExpanded, categories_selected } =
        useContext(EquipmentContext);

    useEffect(() => {
        if (!isDeviceExpanded) {
            setExpandedDevice({});
        }
    }, [isDeviceExpanded]);

    const handlePurchaseTypeChanged = (event, type) => {
        event.persist();
        const { type: prevType } = expandedDevice;
        const newState = {
            ...expandedDevice,
            type,
        };
        setExpandedDevice(newState);

        const { equipment_slug: slug } = newState;

        if (prevType) {
            updateSelectedEquipments((prevState) => {
                const purchaseType = prevState[type] || {};
                const equipments = purchaseType[slug] || [];

                const prevPurchaseType = prevState[prevType] || {};
                const prevEquipments = prevPurchaseType[slug] || [];

                return {
                    ...prevState,
                    [prevType]: {
                        ...prevPurchaseType,
                        [slug]: prevEquipments.slice(0, -1),
                    },
                    [type]: {
                        ...purchaseType,
                        [slug]: [...equipments, newState],
                    },
                };
            });
        } else {
            updateSelectedEquipments((prevState) => {
                const purchaseType = prevState[type] || {};
                const equipments = purchaseType[slug] || [];

                return {
                    ...prevState,
                    [type]: {
                        ...purchaseType,
                        [slug]: [...equipments, newState],
                    },
                };
            });
        }
    };

    const handleInputChange = (name, value) => {
        const { type } = expandedDevice;
        const newState = {
            ...expandedDevice,
            [name]: value,
        };

        setExpandedDevice(newState);

        const { equipment_slug: slug } = newState;

        updateSelectedEquipments((prevState) => {
            const purchaseType = prevState[type] || {};
            const equipments = purchaseType[slug] || [];
            equipments[equipments.length - 1] = newState;

            return {
                ...prevState,
                [type]: {
                    ...purchaseType,
                    [slug]: [...equipments],
                },
            };
        });
    };

    const onResetSelectedDevice = () => {
        setExpandedDevice({});
        setIsDeviceExpanded(false);
    };

    const renderActionBtn = () => {
        return (
            <Button
                startIcon={<FaPlusCircle className="add-devices-icon" />}
                className="add-device-btn"
                onClick={onResetSelectedDevice}
            >
                Add add'l devices
            </Button>
        );
    };

    const renderEquipments = (equipments, is_child = false) => {
        return equipments.map((equipment, i) => {
            return (
                <EquipmentTile
                    key={equipment.id}
                    equipment={equipment}
                    onDeviceExpand={(equipment) => {
                        setExpandedDevice(equipment);
                        setIsDeviceExpanded(true);
                    }}
                    is_child={is_child}
                />
            );
        });
    };

    const handleOtherGatewayChange = (e) => {
        setFormDataByKeyValue(e.target.name, e.target.value);
    };

    return (
        <div>
            <div className="equipment-box">
                {enableLegend && (
                    <p className="box-label">{category.category_name}</p>
                )}
                <div className="eqp-row">
                    {expandedDevice?.id ? (
                        <Equipment
                            key={expandedDevice.id}
                            equipment={expandedDevice}
                            handleInputChange={handleInputChange}
                            handleTypeCheck={handlePurchaseTypeChanged}
                            allEquipments={allEquipments}
                            onDeselectEquipment={onResetSelectedDevice}
                            renderActionBtn={renderActionBtn}
                        />
                    ) : (
                        renderEquipments(category.equipments)
                    )}
                </div>
                {category.other_field_enable == 1 && (
                    <div class="input-wrapper-override">
                        <TextField
                            value={form_data.other_gateway}
                            name="other_gateway"
                            label="Other: Please specify"
                            onChange={handleOtherGatewayChange}
                        />
                    </div>
                )}
                {!expandedDevice?.id &&
                    category.add_ons.length > 0 &&
                    categories_selected?.includes(category?.category) && (
                        <div className="addon-box">
                            <hr className="horizontal-rule" />
                            <p className="sub-heading-lead">
                                Additional add-ons for your{" "}
                                {category.category_name}
                            </p>
                            <div className="eqp-row">
                                {renderEquipments(category.add_ons, true)}
                            </div>
                        </div>
                    )}
            </div>
        </div>
    );
};

export default Category;
